__turbopack_context__.v({
  "accordion": "Accordion-module__Bj4qma__accordion",
  "accordionOpen": "Accordion-module__Bj4qma__accordionOpen",
  "header": "Accordion-module__Bj4qma__header",
  "headerArrow": "Accordion-module__Bj4qma__headerArrow",
  "headerDisabled": "Accordion-module__Bj4qma__headerDisabled",
  "headerOpen": "Accordion-module__Bj4qma__headerOpen",
  "titleIcon": "Accordion-module__Bj4qma__titleIcon",
  "toggleText": "Accordion-module__Bj4qma__toggleText",
});
